export default __webpack_public_path__ + "static/media/ios share button.74e37324.svg";